var _circle, _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMhcIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0829,
    cy: 26.8123,
    r: 26,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6017,
    y: 26.2431,
    width: 7.15233,
    height: 11.2152,
    fill: "#153A71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0447,
    y: 21.8623,
    width: 7.15233,
    height: 15.596,
    fill: "#153A71"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4877,
    y: 28.7986,
    width: 7.15233,
    height: 8.65963,
    fill: "#153A71"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0599,
    y: 37.4583,
    width: 29.1218,
    height: 0.781279,
    fill: "#153A71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2295 13.9044C26.2893 13.7201 26.55 13.7201 26.6099 13.9044L27.2228 15.7909C27.2496 15.8733 27.3264 15.929 27.4131 15.929H29.3966C29.5904 15.929 29.6709 16.177 29.5142 16.2909L27.9094 17.4568C27.8393 17.5077 27.81 17.598 27.8368 17.6804L28.4497 19.5668C28.5096 19.7511 28.2987 19.9043 28.142 19.7904L26.5372 18.6245C26.4671 18.5736 26.3722 18.5736 26.3021 18.6245L24.6974 19.7904C24.5406 19.9043 24.3298 19.7511 24.3896 19.5668L25.0026 17.6804C25.0293 17.598 25 17.5077 24.9299 17.4568L23.3252 16.2909C23.1684 16.177 23.249 15.929 23.4427 15.929H25.4263C25.5129 15.929 25.5897 15.8733 25.6165 15.7909L26.2295 13.9044Z",
    fill: "#97144D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhcIcon);
export default __webpack_public_path__ + "static/media/mhcIcon.ba4865f375adee46fb0800258ea4c817.svg";
export { ForwardRef as ReactComponent };